export default class DateDeliverySelector
{
    constructor(dateList = [])
    {
        this._dateList = dateList;
        this._html = ``;
    }

    getHtmlDaySelector()
    {
        let select = BX.create('select');
        select.classList.add("lpost-delivery-day-selector", "input-date-day-delivery");

        this._dateList.forEach((e, i) => {
            BX.selectUtils.addNewOption(select,  e.DateDelive, e.DateDelive);
        })

        return select.outerHTML;
    }

    getHtmlTimeSelector(valueList = [], indexId)
    {

        let select = BX.create('select');
        select.classList.add("lpost-delivery-time-selector", 'input-date-time-delivery');
        select.dataset.id = indexId;

        valueList.forEach((e, i) => {
            BX.selectUtils.addNewOption(select, `${e.TimeFrom},${e.TimeTo}`, `${e.TimeFrom} - ${e.TimeTo}`);
        })

        return select.outerHTML;
    }

    getHtmlTimeSelectorList()
    {
        let selectHtmlList = '';

        this._dateList.forEach((e,i) => {
            selectHtmlList += this.getHtmlTimeSelector(e.Intervals, e.DateDelive);
        })

        return selectHtmlList;
    }

    getTimeDefaultValue()
    {
        return this._dateList[0]["Intervals"][0]["TimeFrom"] + "," + this._dateList[0]["Intervals"][0]["TimeTo"]
    }

    getDayDefaultValue()
    {
        return this._dateList[0]["DateDelive"];
    }

    generate()
    {
        this._html = `
            <div class="lpost-delivery-date-selector">
                <div class="lpost-delivery-date-selector__row">
                    ${this.getHtmlDaySelector()}
                </div>
                <div class="lpost-delivery-date-selector__row">
                    ${this.getHtmlTimeSelectorList()}
                </div>
            </div>
        `;

        return this;
    }

    getHtml()
    {
        return this._html;
    }

}